import React, { FC, useState } from "react";

import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

import { useRecoilValue } from "recoil";
import {
  isLoggedInSelector,
  permissionsSelector,
} from "../../shared/actions/Authentication.actions";
import { Permissions } from "../../shared/models/Types";

import { useCompanyUpdateMutation } from "./Company.actions";
import CompanyUpdateModal from "./CompanyUpdateModal";
import SmsTab from "./SmsTab";

const CompanyDetail: FC = () => {
  document.title =
    "Müşteri Bilgisi | Bu ekranda müşteri bilgileri düzenlemesi yapabilirsiniz";
  const permissionList = useRecoilValue(permissionsSelector);
  const { profile, company } = useRecoilValue(isLoggedInSelector);

  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const { data, mutate, isLoading } = useCompanyUpdateMutation();

  const [activeTab, toggleTab] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const deleteCustomerPermission = permissionList[Permissions.DeleteCustomer];
  const updateCustomerPermission = permissionList[Permissions.ChangeCustomer];

  return (
    <React.Fragment>
      <Row>
        {/* <Col xl={9} lg={8}> */}
        <Col xl={12} lg={12}>
          <Card>
            <CardBody>
              <Row>
                <div className="col-sm order-2 order-sm-1">
                  <div className="d-flex align-items-start mt-3 mt-sm-0">
                    <div className="avatar-lg d-inline-block align-middle me-2">
                      <div
                        style={{ fontSize: 64 }}
                        className="avatar-title bg-light-subtle text-light font-size-64 m-0 rounded-circle"
                      >
                        <i className="bx bxs-user-circle"></i>
                      </div>
                    </div>

                    <div className="flex-grow-1">
                      <div>
                        <h5 className="font-size-16 mb-1">
                          {!isLoading ? (
                            profile?.fullname
                          ) : (
                            <span className="placeholder col-3"></span>
                          )}
                        </h5>

                        <p className="text-bold font-size-13">
                          {!isLoading ? (
                            `${company?.phone_number1} ${company?.phone_number2} ${company?.phone_number3}`
                          ) : (
                            <span className="placeholder col-4"></span>
                          )}
                        </p>
                        <p className="text-muted font-size-13">
                          {!isLoading ? (
                            `${company?.address}`
                          ) : (
                            <span className="placeholder col-7"></span>
                          )}
                        </p>

                        <p className="text-muted font-size-13">
                          {!isLoading ? (
                            `${company?.email}`
                          ) : (
                            <span className="placeholder col-6"></span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-auto order-1 order-sm-2">
                  <div className="d-flex align-items-start justify-content-between gap-2 mb-3">
                    <div>
                      <button
                        onClick={toggle}
                        type="button"
                        className="btn btn-soft-primary"
                      >
                        <i className="bx bx-cog me-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </Row>

              <Nav className="nav-tabs-custom card-header-tabs border-top mt-4">
                <NavItem>
                  <NavLink
                    href="#"
                    style={{ fontSize: isMobile ? "0.8rem" : "0.875rem" }}
                    className={`${activeTab === "1" ? "active px-3" : "px-3"}`}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    Sms Bilgisi
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink
                    href="#"
                    style={{ fontSize: isMobile ? "0.8rem" : "0.875rem" }}
                    className={`${activeTab === "2" ? "active px-3" : "px-3"}`}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    Ödeme Bilgileri
                  </NavLink>
                </NavItem> */}
              </Nav>
            </CardBody>
          </Card>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <SmsTab />
            </TabPane>
          </TabContent>
        </Col>
      </Row>

      {isModalOpen && (
        <CompanyUpdateModal
          //   mutate={mutate}
          userData={company}
          isModalOpen={isModalOpen}
          toggle={toggle}
        />
      )}
    </React.Fragment>
  );
};

export default CompanyDetail;
